// Enum representing the return policy for a shipment
export enum ShipmentReturnPolicy {
  ReturnToSender = 'ReturnToSender',
  Destroy = 'Destroy',
}

export function isShipmentReturnPolicy(value: unknown): value is ShipmentReturnPolicy {
  if (typeof value !== 'string') {
    return false;
  }
  return Object.values(ShipmentReturnPolicy as Record<string, string>).includes(value);
}
